import { ChevronDown } from "./icons";
import "./accordion.css";

/**
 * A list of disclosures.
 *
 * Native `<details>`, not a JavaScript accordion. It opens before React has
 * hydrated, it is keyboard operable without a single handler, and the
 * browser's own find-in-page can reach text inside a closed one — none of
 * which a div with an onClick gets for free.
 *
 * `render` exists because /help's answers are lists and the home page's are
 * paragraphs. Everything else about the two is identical, and the version this
 * replaces had a second copy of the whole component to accommodate that.
 */
export default function Accordion({ items, getKey, render, className = "" }) {
  return (
    <div className={`accordion ${className}`.trim()}>
      {items.map((item) => (
        <details className="accordion__item" key={getKey(item)}>
          <summary className="accordion__q">
            {item.q}
            <ChevronDown className="accordion__chevron" />
          </summary>
          <div className="accordion__a">
            <div className="accordion__a-inner">{render(item)}</div>
          </div>
        </details>
      ))}
    </div>
  );
}
